module.exports = __webpack_public_path__ + "img/teeth-12.1ca95b7a.png";